import React from "react";

import * as fmt from "formatters";

export default ({thing, namespace, first, last, onClick}) => {
  const formatted = fmt.formatThing(namespace)(thing);
  const {
    contents: {thingName},
  } = namespace.schemas.find(({id}) => id === thing.schemaId) || {
    contents: {thingName: "<Desconocido>"},
  };
  return (
    <div className={["thing-item", first ? "mt-1" : null].filter((c) => c).join(" ")}>
      <button
        type="button"
        className={["btn", "btn-block", first ? "first" : null, last ? "last" : null]
          .filter((c) => c)
          .join(" ")}
        title={formatted}
        onClick={onClick}
      >
        <span className="text-truncate">
          <strong>{thingName}: </strong> {formatted}
        </span>
      </button>
    </div>
  );
};
